<template>

<app-inner class="content" :class="{'is-loading': loading}">

    <div class="content-empty" v-if="!loading && empty && !hideEmpty">

        {{ text.empty }}

    </div>

    <div class="content-body">

        <slot></slot>

    </div>

</app-inner>

</template>

<script>

export default {

    props: ['loading', 'empty', 'text', 'hideEmpty']

}

</script>

<style scoped>

.content {
    min-height: 240px!important;
    padding: 40px 0px;
}

.is-mobile .content {
    min-height: 0px!important;
    padding: 10px 0px;
}

.content.is-loading {
    background-image: url(~@/assets/app.load.gif);
    background-position: 50% 50%;
    background-repeat: no-repeat;
}

.content-empty {
    line-height: 240px;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    color: var(--color-grey);
}

.is-mobile .content-empty {
	line-height: 18px;
	padding: 20px;
	font-size: 14px;
}

.content-body {
    opacity: 1;
    transition: all 100ms linear;
}

.content.is-loading .content-body {
    opacity: 0;
}

</style>